import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom'

//--- Estilos e íconos de Bootstrap ---//
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import './css/styles.min.css'
//--- Estilos e íconos de Bootstrap ---//

// import { Login } from './components/Login/Login'
// import { SecondaryLogin } from './components/Login/SecondaryLogin'
import { Dashboard } from './components/Dashboard/Dashboard'
import { Games } from './components/Games/Games'
import { Lobby } from './components/Lobby/Lobby'
import { NotFound } from './components/Commons/NotFound'
import { GoalFan } from './components/Dashboard/Sections/Goal'
import { SelfieFan } from './components/Dashboard/Sections/SelfieFan'
import { Messages } from './components/Dashboard/Sections/Messages'
import { Noisemeter } from './components/Dashboard/Sections/Noisemeter'

import { Recolector } from './components/Dashboard/Sections/Recolector'
import { PluckingRooster } from './components/Dashboard/Sections/PluckingRooster'
import { ResetPluckingRooster } from './components/Dashboard/Sections/ResetPluckingRooster'
import { Picnic } from './components/Dashboard/Sections/Picnic'
import { Briefcase } from './components/Dashboard/Sections/Briefcase'
import { Tacos } from './components/Dashboard/Sections/Tacos'
import { CatchTheBall } from './components/Dashboard/Sections/CatchTheBall'
import { SlotMachine } from './components/Dashboard/Sections/SlotMachine'
import { Caps } from './components/Dashboard/Sections/Caps'
import { Roulette } from './components/Dashboard/Sections/Roulette'


//--- Admin ---//
import { Login } from './components/Admin/Login/Login'
import { Dashboard as AdmDashboard } from './components/Admin/Dashboard/Dashboard'
import { Colors } from './components/Admin/Games/Colors'
import { Quiz } from './components/Admin/Games/Quiz'
import { Lottery } from './components/Admin/Games/Lottery'
import { FanCamIA } from './components/Admin/FanCam/FanCamIA'
import { SelfieFan as SelfieFanAdmin } from './components/Admin/FanCam/SelfieFan'
import { LyricsGenerator } from './components/Admin/Games/Karaoke/LyricsGenerator'
import { MessagesBoard } from './components/Admin/Overlays/Messages/MessagesBoard'
import { SelfieFanLibrary } from './components/Admin/Games/SelfieFanPlayer/SelfieFanLibrary'
//--- Admin ---//

//--- Screen ---//
import { Screen } from './components/Screen/Screen'
import { ScreenV2 } from './components/Screen/ScreenV2'
import { Karaoke } from './components/Overlays/Karaoke'
import { Messages as MessagesOverlay } from './components/Overlays/Messages'
import { PluckingRooster as PluckingRoosterOverlay } from './components/Overlays/PluckingRooster'
import { SelfieFan as SelfieFanOverlay } from './components/Overlays/SelfieFan'
import { KaraokeCam as KaraokeCamOverlay } from './components/Overlays/KaraokeCam'
import { InteractiveChat as InteractiveChatOverlay } from './components/Overlays/InteractiveChat'
import { SlotMachine as SlotMachineScreen } from './components/Screen/Sections/SlotMachine'
import { Score as ScoreOverlay } from './components/Overlays/Score'
import { Lineup as LineupOverlay } from './components/Overlays/Lineup'
import { Cards as CardsOverlay } from './components/Overlays/Cards'
//import { Noisemeter as NoisemeterOverlay } from './components/Overlays/Noisemeter'
//--- Screen ---//


const StandScreenWrapper = () => {
    let { id } = useParams();
    // Le pasamos el ID a la máquina para que se conecte al WebSocket privado (ej. "slotmachine:screen:1")
    return <SlotMachineScreen screenId={id} />;
}

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route
            path='/'
            element={<Dashboard />}
          />

          {/* <Route
            path="/gol"
            element={<GoalFan />}
          /> */}

          <Route
            path="/selfiefan"
            element={<SelfieFan />}
          />

          <Route
            path="/messages"
            element={<Messages />}
          />

          <Route
            path="/noisemeter"
            element={<Noisemeter />}
          />

          <Route
            path="/abcdef/games/recolector"
            element={<Recolector />}
          />

          <Route
            path="/rooster" ///abcdef/games/rooster
            element={<PluckingRooster />}
          />

          <Route
            path="/xyz/reset/rooster" ///abcdef/games/rooster
            element={<ResetPluckingRooster />}
          />

          <Route
            path="/picnic"
            element={<Picnic />}
          />

          <Route
            path="/briefcase"
            element={<Briefcase />}
          />

          <Route
            path="/tacos"
            element={<Tacos />}
          />

          {/* <Route
            path="/gamepad"
            element={<CatchTheBall />}
          /> */}

          <Route
            path="/slot"
            element={<SlotMachine />}
          />
          
          <Route
            path="/pantalla-stand/:id"
            element={<StandScreenWrapper />}
          />

          <Route
            path="/caps"
            element={<Caps />}
          />

          <Route
            path="/roulette"
            element={<Roulette />}
          />

          {/* <Route
            path='/lobby'
            element={<Lobby />}
          /> */}

          {/* <Route
            path='/games'
            element={<Games />}
          /> */}





          {/* Panel de administración */}
          <Route
            path='/admin'
            element={<Login />}
          />

          <Route
            path='/admin/dashboard'
            element={<AdmDashboard />}
          />

          <Route
            path='/admin/colors'
            element={<Colors />}
          />

          <Route
            path='/admin/quiz'
            element={<Quiz />}
          />

          <Route
            path='/admin/lottery'
            element={<Lottery />}
          />

          <Route
            path='/admin/ia'
            element={<FanCamIA />}
          />

          <Route
            path='/admin/selfiefan'
            element={<SelfieFanAdmin />}
          />

          <Route
            path='/admin/karaoke/create'
            element={<LyricsGenerator />}
          />

          <Route
            path='/xyz/messages/board' //'/admin/messages/board'
            element={<MessagesBoard />}
          />

          <Route
            path='/admin/library/'
            element={<SelfieFanLibrary />}
          />





          {/* Página Screen */}
          <Route
            path='/screen'
            element={<Screen />}
          />

          {/* <Route
            path='/screen-v2'
            element={<ScreenV2 />}
          /> */}

          {/* ===== Overlays ===== */}
          {/* Página Overlay Karaoke */}
          <Route
            path='/abcdef/overlays/karaoke/'
            element={<Karaoke />}
          />

          <Route
            path='/abcdef/overlays/messages/'
            element={<MessagesOverlay />}
          />

          <Route
            path='/abcdef/overlays/rooster/'
            element={<PluckingRoosterOverlay />}
          />

          <Route
            path='/abcdef/overlays/selfiefan/'
            element={<SelfieFanOverlay />}
          />

          <Route
            path='/abcdef/overlays/karaokecam/'
            element={<KaraokeCamOverlay />}
          />

          <Route
            path='/abcdef/overlays/chat/'
            element={<InteractiveChatOverlay />}
          />

          <Route
            path='/abcdef/overlays/score/'
            element={<ScoreOverlay />}
          />

          <Route
            path='/abcdef/overlays/lineup/'
            element={<LineupOverlay />}
          />

          <Route
            path='/abcdef/overlays/card/'
            element={<CardsOverlay />}
          />

          {/* <Route
            path='/abcdef/overlays/noisemeter/'
            element={<NoisemeterOverlay />}
          /> */}





          {/* Página 404 */}
          <Route
            path='*'
            element={<NotFound />}
          />
        </Routes>
      </Router>
    </>
  )
}

export default App